/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { TafConfig } from '../../../types';

export const fakeNafConfig: TafConfig = {
  type: 'NAF',
  location_indicator_mwo: 'EHAK',
  locations: {
    EHAK: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'A12-CPP',
    },
    EHFD: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'F3-FB-1',
    },
    EHDV: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'D15-FA-1',
    },
    EHHW: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'BG-OHVS2',
    },
    EHKV: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'K14-FA-1C',
    },
    EHMG: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'L9-FF-1',
    },
    EHMA: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'AWG-1',
    },
    EHQN: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'HKN',
    },
    EHPG: {
      valid_durations: [9, 9, 9, 6],
      valid_start_times: [5, 8, 11, 14],
      label: 'P11-B',
    },
  },
  locationOrder: [
    'EHAK',
    'EHFD',
    'EHDV',
    'EHHW',
    'EHKV',
    'EHMG',
    'EHMA',
    'EHQN',
    'EHPG',
  ],
  autoTAFlocations: [
    'EHAK',
    'EHFD',
    'EHDV',
    'EHHW',
    'EHKV',
    'EHMG',
    'EHMA',
    'EHQN',
    'EHPG',
  ],
  shouldEnableRemark: true,
};
